import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/prescriptions/`;

export const prescription = {
  get: () => generateApiPath(pathBase),
};
